(function () {
	/* Toggle content */
	$(".product-description-more").click(function (e) {
		e.preventDefault();
		$(this).closest(".product-description-short").next().show();
		$(this).closest(".product-description-short").hide();
	});

	$(".product-description-less").click(function (e) {
		e.preventDefault();
		$(this).closest(".product-description-full").prev().show();
		$(this).closest(".product-description-full").hide();
	});

	/* Toggle fields */
	$(".js-show-more").click(function (e) {
		e.preventDefault();
		$(this).siblings("input").removeClass("hidden");
		$(this).siblings("label").removeClass("hidden");
		$(this).remove();
	});
})();

/* Second floated product form */
class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const rating = this.productElement.querySelector(".rating");
		if (rating) rating.remove();

		const tags = this.productElement.querySelector(".product-tags");
		if (tags) tags.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const advantage = this.productElement.querySelector(".advantage-wrapper");
		if (advantage) advantage.remove();

		const inventory = this.productElement.querySelector(".advantage");
		if (inventory) inventory.remove();

		const note = this.productElement.querySelector(".note");
		if (note) note.remove();

		const promoBanner = this.productElement.querySelector(".promo-banner");
		if (promoBanner) promoBanner.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const productModal = this.productElement.querySelector("product-modal");
		if (productModal) productModal.remove();

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();

		const relatedProduct = this.productElement.querySelector("related-product");
		if (relatedProduct) relatedProduct.remove();

		const gift = this.productElement.querySelector(".customer");
		if (gift) gift.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);

//let sizeBtn = document.querySelector(".pickup-availability-button");
//sizeBtn.addEventListener("click", function () {
//	document.querySelector("size-guide-popup").style.display = "block";

//	document.body.classList.add("overflow-hidden");

//	document.querySelector(".size-guide").style.visibility = "visible";
//});

//let closebtnSize = document.querySelector(".size-guide-close-button");
//closebtnSize.addEventListener("click", function () {
//	document.querySelector("size-guide-popup").style.display = "none";

//	document.body.classList.remove("overflow-hidden");

//	document.querySelector(".size-guide").style.visibility = "hidden";
//});

//	this.onBodyClick = this.handleBodyClick.bind(this);

//	this.querySelector("button").addEventListener("click", () => {
//		this.hide();
//	});

//	this.addEventListener("keyup", () => {
//		if (event.code.toUpperCase() === "ESCAPE") this.hide();
//	});

//handleBodyClick(evt) {
//	const target = evt.target;
//	if (
//		target != this &&
//		!target.closest("size-guide-popup") &&
//		target.id != "ShowSizeGuide"
//	) {
//		this.hide();
//	}
//}

//hide() {
//	this.removeAttribute("open");
//	document.body.removeEventListener("click", this.onBodyClick);
//	document.body.classList.remove("overflow-hidden");
//	removeTrapFocus(this.focusElement);
//	document.querySelector(".size-guide").style.visibility = "hidden";
//}
/* ============================================================
   AMBIENT HOME — HIGH VARIANT PRODUCTS (>250 variants)
   À ajouter à la FIN de assets/main-product.js
   - utilise product_option_value + Section Rendering API
   - ne charge jamais product.variants au complet
   - respecte "Continuer à vendre en cas de rupture"
   ============================================================ */

(function () {
  if (window.__AH_HIGH_VARIANT_PICKER__) return;
  window.__AH_HIGH_VARIANT_PICKER__ = true;

  function q(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function getPickerFromTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-high-variant="true"][data-section]');
  }

  function getChangedOptionElement(target) {
    if (!target) return null;
    if (target.matches('input[type="radio"][data-option-value-id]')) return target;
    if (target.matches('select')) {
      return target.options[target.selectedIndex] || null;
    }
    return null;
  }

  function getSelectedOptionValueIds(picker) {
    var byPosition = {};

    picker.querySelectorAll('input[type="radio"]:checked[data-option-value-id]').forEach(function (input) {
      var pos = parseInt(input.getAttribute('data-option-position') || '0', 10);
      if (pos > 0) byPosition[pos] = input.getAttribute('data-option-value-id');
    });

    picker.querySelectorAll('select').forEach(function (select) {
      var option = select.options[select.selectedIndex];
      if (!option || !option.getAttribute('data-option-value-id')) return;

      var pos = parseInt(
        option.getAttribute('data-option-position') ||
        select.getAttribute('data-option-position') ||
        '0',
        10
      );

      if (pos > 0) byPosition[pos] = option.getAttribute('data-option-value-id');
    });

    return Object.keys(byPosition)
      .map(function (key) { return parseInt(key, 10); })
      .sort(function (a, b) { return a - b; })
      .map(function (key) { return byPosition[key]; })
      .filter(Boolean);
  }

  function parseSelectedVariant(picker) {
    var script = q(picker, 'script[data-selected-variant]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || 'null');
    } catch (e) {
      return null;
    }
  }

  function copyDataAttributes(from, to) {
    if (!from || !to) return;

    Array.prototype.slice.call(to.attributes).forEach(function (attr) {
      if (attr.name.indexOf('data-selected-') === 0) {
        to.removeAttribute(attr.name);
      }
    });

    Array.prototype.slice.call(from.attributes).forEach(function (attr) {
      if (attr.name.indexOf('data-selected-') === 0) {
        to.setAttribute(attr.name, attr.value);
      }
    });
  }

  function patchPicker(livePicker, freshPicker) {
    if (!livePicker || !freshPicker) return;

    copyDataAttributes(freshPicker, livePicker);

    var liveFields = Array.prototype.slice.call(
      livePicker.querySelectorAll('.product-form__controls')
    );
    var freshFields = Array.prototype.slice.call(
      freshPicker.querySelectorAll('.product-form__controls')
    );

    liveFields.forEach(function (liveField, index) {
      var freshField = freshFields[index];
      if (!freshField) return;

      liveField.innerHTML = freshField.innerHTML;
      liveField.className = freshField.className;
      liveField.setAttribute('style', freshField.getAttribute('style') || '');
    });

    var liveSelected = q(livePicker, 'script[data-selected-variant]');
    var freshSelected = q(freshPicker, 'script[data-selected-variant]');

    if (liveSelected && freshSelected) {
      liveSelected.textContent = freshSelected.textContent;
    }
  }

  function copyInnerHTML(liveRoot, freshRoot, selector) {
    var live = q(liveRoot, selector);
    var fresh = q(freshRoot, selector);
    if (!live || !fresh) return;
    live.innerHTML = fresh.innerHTML;
  }

  function syncPrimaryProduct(sectionId, liveRoot, freshRoot, variant) {
    copyInnerHTML(liveRoot, freshRoot, '#price-' + sectionId);
    copyInnerHTML(liveRoot, freshRoot, '#Inventory-' + sectionId);

    var liveRef = q(liveRoot, '#BLM-Ref-' + sectionId);
    var freshRef = q(freshRoot, '#BLM-Ref-' + sectionId);

    if (liveRef && freshRef) {
      liveRef.textContent = freshRef.textContent;
      liveRef.style.display = freshRef.style.display;
    } else if (liveRef && variant) {
      if (variant.sku) {
        liveRef.textContent = 'REFERENCE : ' + variant.sku;
        liveRef.style.display = '';
      } else {
        liveRef.textContent = '';
        liveRef.style.display = 'none';
      }
    }

    var liveForm = document.getElementById('product-form-' + sectionId);
    var freshForm = freshRoot.querySelector('#product-form-' + sectionId);

    if (liveForm && freshForm) {
      var liveId = q(liveForm, 'input[name="id"]');
      var freshId = q(freshForm, 'input[name="id"]');

      if (liveId && freshId) {
        liveId.value = freshId.value || '';
        liveId.setAttribute('value', freshId.value || '');

        if (freshId.disabled) liveId.setAttribute('disabled', 'disabled');
        else liveId.removeAttribute('disabled');

        liveId.dispatchEvent(new Event('change', { bubbles: false }));
      }

      var liveQty = q(liveForm, 'input[name="quantity"]');
      var freshQty = q(freshForm, 'input[name="quantity"]');

      if (liveQty && freshQty) {
        ['min', 'max', 'step', 'data-min', 'data-max', 'data-cart-quantity'].forEach(function (name) {
          if (freshQty.hasAttribute(name)) liveQty.setAttribute(name, freshQty.getAttribute(name));
          else liveQty.removeAttribute(name);
        });
      }

      var liveButton = q(liveForm, 'button[name="add"]');
      var freshButton = q(freshForm, 'button[name="add"]');

      if (liveButton && freshButton) {
        liveButton.innerHTML = freshButton.innerHTML;

        if (freshButton.disabled || !variant || variant.available === false) {
          liveButton.setAttribute('disabled', 'disabled');
        } else {
          liveButton.removeAttribute('disabled');
        }

        if (freshButton.hasAttribute('aria-disabled')) {
          liveButton.setAttribute('aria-disabled', freshButton.getAttribute('aria-disabled'));
        } else {
          liveButton.removeAttribute('aria-disabled');
        }
      }
    }

    var liveMini = q(liveRoot, '.ah-mini-infos');
    var freshMini = q(freshRoot, '.ah-mini-infos');

    if (liveMini && freshMini) {
      ['data-out', 'data-min-bd', 'data-max-bd'].forEach(function (name) {
        if (freshMini.hasAttribute(name)) liveMini.setAttribute(name, freshMini.getAttribute(name));
        else liveMini.removeAttribute(name);
      });

      var eta = q(liveMini, '.ah-mini-infos__eta-text');
      if (eta && (!variant || variant.available === false)) {
        eta.textContent = 'Rupture de stock';
      }
    }
  }

  function getVariantImageSrc(variant) {
    if (!variant) return '';

    if (
      variant.featured_media &&
      variant.featured_media.preview_image &&
      variant.featured_media.preview_image.src
    ) {
      return variant.featured_media.preview_image.src;
    }

    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    if (typeof variant.featured_image === 'string') return variant.featured_image;
    return '';
  }

  function syncSticky(sectionId, liveRoot, freshRoot, variant) {
    copyInnerHTML(liveRoot, freshRoot, '#AH-StickyPrice-' + sectionId);

    var sticky = q(liveRoot, '#AH-StickyATC-' + sectionId);
    if (!sticky) return;

    var stickySelect = q(sticky, '#AH-StickySelect-' + sectionId);
    if (stickySelect) {
      var variantsBox = stickySelect.closest('.ah-sticky-atc__variants');
      if (variantsBox) variantsBox.style.display = 'none';
    }

    var stickyImg = q(sticky, '.ah-sticky-atc__image');
    var imageSrc = getVariantImageSrc(variant);

    if (stickyImg && imageSrc) {
      try {
        var imageUrl = new URL(imageSrc, window.location.origin);
        imageUrl.searchParams.set('width', '80');
        stickyImg.src = imageUrl.toString();
      } catch (e) {
        stickyImg.src = imageSrc;
      }
    }
  }

  function goToVariantMedia(sectionId, liveRoot, variant) {
    if (!variant || !variant.featured_media || !variant.featured_media.id) return;

    var key = sectionId + '-' + variant.featured_media.id;
    var thumb =
      liveRoot.querySelector('[data-media-sub-id="' + key + '"]') ||
      null;

    if (thumb && typeof thumb.click === 'function') thumb.click();

    var slide = liveRoot.querySelector('[data-media-id="' + key + '"]');
    if (!slide) return;

    var slider = slide.closest('.swiper');
    if (slider && slider.swiper) {
      var slides = Array.prototype.slice.call(
        slider.querySelectorAll('.product__media-item.swiper-slide, .product__media-item')
      );
      var index = slides.indexOf(slide);
      if (index > -1) slider.swiper.slideTo(index, 350);
    }
  }

  function syncSwatchMap(sectionId, freshDocument) {
    var liveMap = document.getElementById('AH-SwatchMap-' + sectionId);
    var freshMap = freshDocument.getElementById('AH-SwatchMap-' + sectionId);

    if (liveMap && freshMap) liveMap.textContent = freshMap.textContent;
  }

  function updateHistory(picker, productUrl, selectedIds, variant) {
    if (picker.getAttribute('data-update-url') === 'false') return;

    var url = new URL(productUrl || picker.getAttribute('data-url') || window.location.pathname, window.location.origin);
    url.search = '';

    if (variant && variant.id) {
      url.searchParams.set('variant', variant.id);
    } else if (selectedIds.length) {
      url.searchParams.set('option_values', selectedIds.join(','));
    }

    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function setLoading(picker, loading) {
    if (!picker) return;
    if (loading) picker.setAttribute('aria-busy', 'true');
    else picker.removeAttribute('aria-busy');
  }

  function refreshHighVariantState(picker, changedElement) {
    var sectionId = picker.getAttribute('data-section');
    if (!sectionId) return;

    var selectedIds = getSelectedOptionValueIds(picker);
    if (!selectedIds.length) return;

    var productUrl =
      (changedElement && changedElement.getAttribute('data-product-url')) ||
      picker.getAttribute('data-url') ||
      window.location.pathname;

    if (picker.__ahAbortController) {
      try { picker.__ahAbortController.abort(); } catch (e) {}
    }

    var controller = new AbortController();
    picker.__ahAbortController = controller;

    var requestUrl = new URL(productUrl, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);
    requestUrl.searchParams.set('option_values', selectedIds.join(','));

    setLoading(picker, true);

    fetch(requestUrl.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      signal: controller.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Variant refresh failed: ' + response.status);
        return response.text();
      })
      .then(function (responseText) {
        var freshDocument = new DOMParser().parseFromString(responseText, 'text/html');
        var liveRoot = document.getElementById('MainProduct-' + sectionId);
        var freshRoot = freshDocument.getElementById('MainProduct-' + sectionId);
        var freshPicker =
          freshDocument.getElementById('variant-radios-' + sectionId) ||
          freshDocument.getElementById('variant-selects-' + sectionId);

        if (!liveRoot || !freshRoot || !freshPicker) {
          throw new Error('Variant refresh HTML incomplete');
        }

        patchPicker(picker, freshPicker);
        syncSwatchMap(sectionId, freshDocument);

        var variant = parseSelectedVariant(picker);

        syncPrimaryProduct(sectionId, liveRoot, freshRoot, variant);
        syncSticky(sectionId, liveRoot, freshRoot, variant);
        goToVariantMedia(sectionId, liveRoot, variant);
        updateHistory(picker, productUrl, selectedIds, variant);

        if (
          window.AHVariantDrawerSync &&
          typeof window.AHVariantDrawerSync[sectionId] === 'function'
        ) {
          window.AHVariantDrawerSync[sectionId]();
        }

        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: variant }
        }));
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        console.error('[Ambient Home] High variant picker:', error);

        var fallback = new URL(productUrl, window.location.origin);
        fallback.searchParams.set('option_values', selectedIds.join(','));
        window.location.assign(fallback.toString());
      })
      .finally(function () {
        setLoading(picker, false);
      });
  }

  document.addEventListener('change', function (event) {
    var picker = getPickerFromTarget(event.target);
    if (!picker) return;

    var changedElement = getChangedOptionElement(event.target);
    if (!changedElement) return;

    refreshHighVariantState(picker, changedElement);
  });

  function prepareExistingHighVariantPickers() {
    document.querySelectorAll('[data-high-variant="true"][data-section]').forEach(function (picker) {
      var sectionId = picker.getAttribute('data-section');
      var root = document.getElementById('MainProduct-' + sectionId);
      if (!root) return;

      var stickySelect = root.querySelector('#AH-StickySelect-' + sectionId);
      if (stickySelect) {
        var variantsBox = stickySelect.closest('.ah-sticky-atc__variants');
        if (variantsBox) variantsBox.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareExistingHighVariantPickers, { once: true });
  } else {
    prepareExistingHighVariantPickers();
  }
})();
